import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { TechModule } from '@schir-int-client/tech';
import { WiedervorlageListComponent } from './wiedervorlage-list/wiedervorlage-list.component';
import { WiedervorlageComponent } from './wiedervorlage-list/wiedervorlage/wiedervorlage.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { RouterModule } from '@angular/router';
import { AktenzeichenModule } from '@schir-int-client/aktenzeichen';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
	imports: [
		CommonModule,
		TechModule,
		FormsModule,
		ReactiveFormsModule,
		MatFormFieldModule,
		MatInputModule,
		MatButtonModule,
		MatDatepickerModule,
		MatDialogModule,
		MatTooltipModule,
		ClipboardModule,
		MatSnackBarModule,
		RouterModule,
		AktenzeichenModule,
	],
	declarations: [WiedervorlageListComponent, WiedervorlageComponent],
	exports: [WiedervorlageListComponent],
})
export class WiedervorlageModule {}
